import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { Grid, withWidth } from '@material-ui/core';
import CustomTypo from '../../components/CustomTypo';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import Carousel from 'react-elastic-carousel'

const styles = theme => ({
    container: {
        // borderWidth:1,
        borderRadius: 10,
        backgroundColor: theme.palette.background.box,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(16),
        height: 230,
    },
    item: {
        width: 200,
        height: 180,
        marginLeft: '5%',
        marginRight: '5%',
        border: '1px solid',
        borderColor: theme.palette.border.primary,
        // justifyContent: 'center',
        alignItems: 'center',
        // paddingTop: 4,
        paddingBottom: 4,
        borderRadius: 4,
        cursor: 'pointer'
    },
    item_image: {
        height: 100,
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        // marginTop: 8,
    },
    item_name: {
        height: 40,
    },
})
function CrossellProductsComponent(props) {

        const { crossellProducts, currency,onSelectCrossellProduct, classes, t } = props;
        
        let width = window.innerWidth
        let number = (width*40/100)/180; 
        if(width<600){
            number = width/300; 
        }
        console.log("AAAAAA number:", number)
        return (
            <Grid item className={classes.container}>
                <CustomTypo center variant='subtitle2'>{t('recommendations')}</CustomTypo>
{/* 
                     <CarouselProvider
                                        naturalSlideWidth={100}
                                        naturalSlideHeight={96}
                                        totalSlides={crossellProducts.length}
                                        visibleSlides={number}
                                        isPlaying={true}
                                        interval={2000}
                                        touchEnabled={true}
                                    >
                                    <Slider>
                                    {crossellProducts.map((product, index) =>
                                        <Slide index={index}> <ProductComponent classes={classes} key={index} index={index} product={product} currency={currency} onSelectCrossellProduct={onSelectCrossellProduct}/></Slide>
                                        )}
                                    </Slider>
                                    </CarouselProvider> */}
                        <Carousel itemsToShow={number}>
                            {crossellProducts.map((product, index) =>
                                <ProductComponent classes={classes} key={index} index={index} product={product} currency={currency} onSelectCrossellProduct={onSelectCrossellProduct}/>
                                )}
                        </Carousel>
            </Grid>
        )
}

function ProductComponent(props) {
    var {classes, product} = props
    var price = dataUtil.getProductPrice(product.pricing) ? dataUtil.getProductPrice(product.pricing).toFixed(2) : "0.00"
    return (
        <Grid item onClick={() => props.onSelectCrossellProduct(product)} className={classes.item}>
            <Grid item className={classes.item_image}>
                <ProductImage classes={classes} image={dataUtil.getImageByUsageTypePortal(product.creatives, usage_type.product_item)} />
            </Grid>
            <Grid item className={classes.item_name}>
                <CustomTypo variant='body2' center>{product.name}</CustomTypo>
            </Grid>
            <Grid item className={classes.item_footer}>
                <CustomTypo center mg_top_xs variant='subtitle2'>{props.currency}{price}</CustomTypo>
            </Grid>
        </Grid>
    )
}

function ProductImage(props) {
    var {classes, image} = props
    if (image && image.url) {
        return <img src={image.url } style={{height: 100, width: '100%',borderTopLeftRadius: 4,borderTopRightRadius: 4, objectFit: 'contain'}} />
    } else {
        return <Grid item className={classes.item_image} />
    }
}

export default withStyles(styles)(withTranslation()(CrossellProductsComponent));